import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "../locales/en/translation.json";
import ar from "../locales/ar/translation.json";
// Right-to-left text alignment for Arabic (headings, labels, sentence punctuation).
import "./arabic-rtl.css";

// Content-creator-only language switcher. To add a new language later:
// drop a new src/locales/<lang>/translation.json and register it below —
// no other code changes needed.
export const SUPPORTED_LANGUAGES = {
  en: { label: "English", nativeLabel: "English", dir: "ltr" },
  ar: { label: "Arabic", nativeLabel: "العربية", dir: "rtl" },
};

export const CONTENT_CREATOR_LANGUAGE_STORAGE_KEY = "cc_language";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
  },
  lng: localStorage.getItem(CONTENT_CREATOR_LANGUAGE_STORAGE_KEY) || "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export default i18n;
